<template>
  <div>
    <div class="content-i">
      <div class="content-box pb-0">
        <div class="element-wrapper pb-0">
          <h6 class="element-header">
            {{t('titleInvoicingReport', 'titleInvoicingReport')}}
          </h6>
          <div class="element-box">
            <div class="element-info my-0">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-search2">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">
                        {{t('titleInvoicingReport', 'titleInvoicingReport')}}
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-3 col-md-4">
                  <i id="textToggle" v-b-toggle.search class="text-primary os-icon os-icon-arrow-up float-right showhand"></i>
                </div>
              </div>
            </div>
            <b-collapse id="search" ref="searchForm" v-model="visibleSearchBox">
              <form v-on:submit.prevent="loadInvoicingReport">
                <div class="row">
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="client" class="d-block text-center"> {{t('labelClientIs', 'labelClientIs')}} </label>
                        <b-form-select v-model="reportRequest.client" :options="clients" value-field="short_name" text-field="title">
                          <template #first>
                            <b-form-select-option value="all"> {{t('optionAllClients', 'optionAllClients')}} </b-form-select-option>
                          </template>
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="document-reference" class="d-block text-center"> {{t('labelDocumentReferenceContains', 'labelDocumentReferenceContains')}} </label>
                        <b-input id="document-reference" v-model="reportRequest.document_reference" class="form-control text-center" :placeholder="t('labelDocumentReferenceContains', 'labelDocumentReferenceContains')"></b-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="date-from" class="d-block text-center"> {{t('labelDocumentDateFrom', 'labelDocumentDateFrom')}} </label>
                        <datePicker id="date-from" v-model="reportRequest.date_from" class="form-control text-center" :config="datePickerFromConfig" :placeholder="t('labelDocumentDateFrom', 'labelDocumentDateFrom')"></datePicker>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="date-to" class="d-block text-center"> {{t('labelDocumentDateTo', 'labelDocumentDateTo')}} </label>
                        <datePicker id="date-to" v-model="reportRequest.date_to" class="form-control text-center" :config="datePickerToConfig" :placeholder="t('labelDocumentDateTo', 'labelDocumentDateTo')"></datePicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="customer-reference" class="d-block text-center"> {{t('labelCustomerReferenceContains', 'labelCustomerReferenceContains')}} </label>
                        <b-input id="customer-reference" v-model="reportRequest.customer_reference" class="form-control text-center" :placeholder="t('labelCustomerReferenceContains', 'labelCustomerReferenceContains')"></b-input>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="customer-name" class="d-block text-center"> {{t('labelCustomerNameContains', 'labelCustomerNameContains')}} </label>
                        <b-input id="customer-name" v-model="reportRequest.customer_name" class="form-control text-center" :placeholder="t('labelCustomerNameContains', 'labelCustomerNameContains')"></b-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-between pt-3">
                  <div class="col-lg-2">
                    <b-input-group class="col-lg-12">
                      <b-input-group-prepend>
                        <label class="input-group-text"> {{ t('paginationPerPage','paginationPerPage') }} </label>
                      </b-input-group-prepend>
                      <b-form-select v-model="perPage" :options="pageOptions" @change="loadInvoicingReport"></b-form-select>
                    </b-input-group>
                  </div>
                  <div class="col-lg-4 text-right mt-3">
                    <button v-if="!loading" class="btn btn-primary" type="submit" > {{ t('searchButtonText', 'searchButtonText') }} </button>
                    <b-button v-else variant="primary" disabled>
                      <b-spinner small type="grow"></b-spinner>
                      {{t('searchButtonText', 'searchButtonText')}}
                    </b-button>
                  </div>
                </div>
              </form>
            </b-collapse>
          </div>
        </div>
        <div class="element-wrapper mt-0 pb-0 pt-0">
          <ResponseInfo v-if="getResponseInfo.responseName == 'invoicingReportView'" />
        </div>
      </div>
    </div>
    <div class="content-i" v-if="items">
      <div class="content-box pt-0">
        <div class="element-wrapper">
          <div class="element-box">
            <div class="element-box-tp">
              <div class="controls-below-table row">
                <div class="col-sm-12 col-lg-4 col-md-12 table-records-info">
                  <p> {{totalRows}} {{ t('invoicesListEntriesFound','invoicesListEntriesFound') }} </p>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-8">
                  <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" aria-controls="invoicing-report-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-lg-2 col-md-4">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text"> {{ t('paginationPerPage','paginationPerPage') }} </label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
                <div class="col-lg-12 col-sm-12 col-md-12 text-right">
                  <button v-if="!reportGenerating && !loading" class="btn btn-primary" @click="exportInvoicingReportAsCSV()"> {{t('buttonInvoicingReportExportAsCsv', 'buttonInvoicingReportExportAsCsv')}} </button>
                  <b-button v-else variant="primary" disabled>
                    {{t('buttonInvoicingReportExportAsCsv', 'buttonInvoicingReportExportAsCsv')}}
                  </b-button>
                </div>
              </div>
              <b-table id="invoicing-report-table" class="mt-3" responsive striped hover bordered :fields="fields" :busy.sync="loading" :items="items" :currentPage="currentPage" :total-rows="totalRows" :show-empty="true" foot-clone :thead-class="'brand-color'" :tfoot-class="'footer-summary'">
                <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="items">
                  <vcl-table :rows="5" :columns="fields.length"></vcl-table>
                </template>
                <template v-slot:head(checkbox)="data">
                  <template v-if="!allSelected">
                    <fontAwesomeIcon @click="checkAllInvoices()" :icon="['far', 'square']" class="showhand" size="2x"/>
                  </template>
                  <template v-else>
                    <fontAwesomeIcon @click="unCheckAllInvoices()" :icon="['far', 'check-square']" class="showhand" size="2x"/>
                  </template>
                </template>
                <template v-slot:head(inv_date)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(cust_ref)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(doc_ref)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(total_pages)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(currency)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(total_value)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(vat_value)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(stamp_rate)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(vat_in_gbp)="data">
                  <span >{{ t(data.label, data.label) }}(£)</span>
                </template>
                <template v-slot:head(stamp_in_gbp)="data">
                  <span >{{ t(data.label, data.label) }}(£)</span>
                </template>
                <template v-slot:head(total_exc_vat)="data">
                  <span> {{t('labelNetValue', 'labelNetValue')}} <br> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(total_exc_vat_stamp)="data">
                  <span> {{t('labelNetValue', 'labelNetValue')}} <br> {{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(total_exc_vat_in_gbp)="data">
                  <span> {{t('labelNetValue', 'labelNetValue')}} <br> {{ t(data.label, data.label) }}(£)</span>
                </template>

                <template v-slot:cell(checkbox)="data">
                  <b-form-group class="my-0">
                    <b-form-checkbox-group v-model="selectedInvoices" name="invoices" class="d-flex justify-content-center">
                      <b-form-checkbox class="my-0 pl-0" :value="data.item.doc_id"></b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </template>

                <template v-slot:cell(doc_ref)="data">
                  <router-link :to="{ name: 'view_document', params: { id: data.item.doc_id, type: 'online' }}" :title="data.item.doc_ref" target="_blank">
                    {{ data.item.doc_ref }}
                  </router-link>
                </template>

                <template v-slot:cell(vat_in_gbp)="data">
                  <span> £{{data.item.vat_in_gbp}}</span>
                </template>
                <template v-slot:cell(stamp_in_gbp)="data">
                  <span> £{{data.item.stamp_in_gbp}}</span>
                </template>
                <template v-slot:cell(total_exc_vat_in_gbp)="data">
                  <span> £{{data.item.total_exc_vat_in_gbp}}</span>
                </template>

                <template v-slot:foot(checkbox)="data">
                  <span> </span>
                </template>
                <template v-slot:foot(inv_date)="data">
                  <span> </span>
                </template>
                <template v-slot:foot(cust_ref)="data">
                  <span> </span>
                </template>
                <template v-slot:foot(doc_ref)="data">
                  <span> </span>
                </template>
                <template v-slot:foot(total_pages)="data">
                  <span> </span>
                </template>
                <template v-slot:foot(currency)="data">
                  <span> {{t('labelTotals', 'labelTotals')}}: </span>
                </template>
                <template v-slot:foot(total_value)="data">
                  <span> {{ calculations['total_value_total']}} </span>
                </template>
                <template v-slot:foot(vat_value)="data">
                  <span> {{ calculations['vat_value_total']}} </span>
                </template>
                <template v-slot:foot(total_exc_vat)="data">
                  <span> {{ calculations['net_value_exc_vat_total']}} </span>
                </template>
                <template v-slot:foot(stamp_rate)="data">
                  <span> {{ calculations['stamp_rate_total']}}</span>
                </template>
                <template v-slot:foot(total_exc_vat_stamp)="data">
                  <span> {{ calculations['total_exc_vat_stamp_total']}}</span>
                </template>
                <template v-slot:foot(vat_in_gbp)="data">
                  <span> £{{ calculations['net_vat_gbp']}}</span>
                </template>
                <template v-slot:foot(stamp_in_gbp)="data">
                  <span> £{{ calculations['net_stampcost_gbp']}} </span>
                </template>
                <template v-slot:foot(total_exc_vat_in_gbp)="data">
                  <span> £{{ calculations['net_val_gbp']}}</span>
                </template>
              </b-table>
              <div class="controls-below-table mt-4 row">
                <div class="col-sm-12 col-lg-4 col-md-12 table-records-info">
                  <p> {{totalRows}} {{ t('invoicesListEntriesFound', 'invoicesListEntriesFound') }} </p>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-8">
                  <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" aria-controls="invoicing-report-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-lg-2 col-md-4">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text"> {{ t('paginationPerPage','paginationPerPage') }} </label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalDownloadData :dataUrl="dataUrl" />
    <ModalInformation :informationTextKey="informationTextKey" :informationTextTitle="informationTextTitle"/>
    <div v-if="alertShowing" class="modal-backdrop show"></div>
  </div>
</template>

<script>
import {VclTable} from 'vue-content-loading'
import ResponseInfo from '@/components/ResponseInfo.vue'
import {mapGetters} from "vuex"
import moment from "moment"
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import ModalInformation from '@/components/Helper_Components/ModalInformation.vue'
import ModalDownloadData from '@/components/Helper_Components/ModalDownloadData.vue'
import { backendUrl } from '@/helpers/backendUrl.js'

export default {
  name: 'InvoicingReport',
  components: {
    VclTable,
    ResponseInfo,
    datePicker,
    ModalDownloadData,
    ModalInformation
  },
  data() {
    return {
      selectedInvoices: [],
      reportGenerating: false,
      informationTextKey: 'infoDownloadInvoicingReportModal',
      informationTextTitle: 'titleDownloadInvoicingReportModal',
      dataUrl: null,
      reportRequest: {
        document_reference: this.$route.query.document_reference,
        customer_reference: this.$route.query.customer_reference,
        customer_name: this.$route.query.customer_name,
        date_from: this.$route.query.date_from,
        date_to: this.$route.query.date_to,
        client: this.$route.query.client ? this.$route.query.client : 'all',
      },
      visibleSearchBox: true,
      datePickerFromConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        showClear: true
      },
      datePickerToConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        minDate: moment(new Date('1979-01-01'), this.datePickerFormat),
        showClear: true
      },
      fields: [
        {key: 'checkbox', label: 'checkbox', sortable: false, thClass: 'hover-pointer'},
        {key: 'inv_date', label: 'tableHeadInvDate', sortable: true, thClass: 'hover-pointer'},
        {key: 'cust_ref', label: 'tableHeadCustomerRef', sortable: true, thClass: 'hover-pointer'},
        {key: 'doc_ref', label: 'tableHeadDocRef', sortable: true, thClass: 'hover-pointer'},
        {key: 'total_pages', label: 'tableHeadTotalPages', sortable: true, thClass: 'hover-pointer'},
        {key: 'currency', label: 'tableHeadCurrency', sortable: true, thClass: 'hover-pointer'},
        {key: 'total_value', label: 'tableHeadTotalValue', sortable: true, thClass: 'hover-pointer'},
        {key: 'vat_value', label: 'tableHeadVatValue', sortable: true, thClass: 'hover-pointer'},
        {key: 'total_exc_vat', label: 'tableHeadTotalExcVat', sortable: true, thClass: 'hover-pointer'},
        {key: 'stamp_rate', label: 'tableHeadStampRate', sortable: true, thClass: 'hover-pointer'},
        {key: 'total_exc_vat_stamp', label: 'tableHeadTotalExcVatStamp', sortable: true, thClass: 'hover-pointer'},
        {key: 'vat_in_gbp', label: 'tableHeadVatValue', sortable: true, thClass: 'hover-pointer', tdClass: 'total-results'},
        {key: 'stamp_in_gbp', label: 'tableHeadStampRate', sortable: true, thClass: 'hover-pointer', tdClass: 'total-results'},
        {key: 'total_exc_vat_in_gbp', label: 'tableHeadTotalExcVatStamp', sortable: true, thClass: 'hover-pointer', tdClass: 'total-results'},
      ],
      currentPage: this.$route.query.page ? this.$route.query.page : 1,
      perPage: this.$route.query.per_page ? this.$route.query.per_page : 20,
      pageOptions: [10, 20, 50, 100, 200, 500],
      loading: false,
      alertShowing: false
    }
  },
  watch: {
    dateFrom(date) {
      if (date) {
        this.datePickerToConfig.minDate = moment(date, this.datePickerFormat)
      } else {
        this.datePickerToConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
      }
    },
    perPage(newCount, oldCount) {
      if (newCount != oldCount) {
        this.loadInvoicingReport()
      }
    },
    currentPage(newCount, oldCount) {
      if (newCount != oldCount) {
        this.loadInvoicingReport()
      }
    },
  },
  methods: {
    loadClients() {
      this.$store.dispatch('loadInvoicingActiveClients')
    },
    exportInvoicingReportAsCSV(){
      if (this.selectedInvoices.length > 0) {
        this.reportGenerating = true
        this.$store.dispatch('prepareInvoicingReportCsv', { documents: this.selectedInvoices })
          .then(response => {
            this.reportGenerating = false
            if (response.fileUrl && response.status === 'success') {
              this.dataUrl = backendUrl() + '/downloadInvoicingReportCsv/' + response.fileUrl
              this.alertShowing = true
              this.$root.$emit('bv::show::modal', 'downloadModal')
            }
          })
      } else {
        this.alertShowing = true
        this.$root.$emit('bv::show::modal', 'informationModal')
      }
    },
    checkAllInvoices() {
      let allInvoicesIds = []
      Object.keys(this.items).forEach((key) => (allInvoicesIds.push(this.items[key].doc_id)))

      this.selectedInvoices = allInvoicesIds
    },
    unCheckAllInvoices() {
      this.selectedInvoices = []
    },
    loadInvoicingReport() {
      this.loading = true

      Object.keys(this.reportRequest).forEach((key) => (this.reportRequest[key] === '' || this.reportRequest[key] === null)  && (this.reportRequest[key] = undefined))
      this.$router.push({ query: { ...this.$route.query, ...this.reportRequest, page: this.currentPage, per_page: this.perPage } })

      this.$store.dispatch('loadInvoicingReport', {
        document_reference: this.reportRequest.document_reference,
        customer_reference: this.reportRequest.customer_reference,
        customer_name: this.reportRequest.customer_name,
        date_from: this.reportRequest.date_from,
        date_to: this.reportRequest.date_to,
        client: this.reportRequest.client,
        page: this.currentPage,
        per_page: this.perPage,
      }).finally(() => {
        this.loading = false
        this.visibleSearchBox = false
      })
    },
  },
  computed: {
    ...mapGetters(['getResponseInfo']),
    allSelected: {
      get() {
        let selected = this.selectedInvoices
        if (this.items.length) {
          for (let i = 0; i < this.items.length; i++) {
            if (!selected.includes(this.items[i].doc_id)) {
              return false
            }
          }
        }

        return true
      }
    },
    dateFrom() {
      return this.reportRequest.date_from
    },
    clients: {
      get() {
        return this.$store.getters.getInvoicingActiveClients
      }
    },
    datePickerFormat() {
      if (this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        return this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
      } else {
        return 'DD-MM-YYYY'
      }
    },
    invoicingReport: {
      get() {
        return this.$store.getters.getInvoicingReport
      },
      set() {
        return this.$store.commit('setInvoicingReport', [])
      }
    },
    items: {
      get() {
        if (this.invoicingReport && this.invoicingReport.data) {
          return this.invoicingReport.data
        }

        return null
      }
    },
    calculations: {
      get() {
        if (this.invoicingReport && this.invoicingReport.calculations) {
          return this.invoicingReport.calculations
        }

        return null
      }
    },
    totalRows: {
      get() {
        if (this.invoicingReport && this.invoicingReport.total) {
          return this.invoicingReport.total
        }

        return 0
      }
    },
  },
  created() {
    this.loadClients()

    this.datePickerFromConfig.format = this.datePickerFormat
    this.datePickerToConfig.format = this.datePickerFormat
    this.$store.dispatch('alertClearResponse')

    if (Object.keys(this.$route.query).length) {

      if (this.$route.query.page) {
        this.currentPage = parseInt(this.$route.query.page)
      }
      if (this.$route.query.per_page) {
        this.perPage = parseInt(this.$route.query.per_page)
      }

      this.loadInvoicingReport()
    }
  },
  beforeDestroy(){
    this.invoicingReport = []
  },
}

</script>

<style scoped>

.table-responsive >>> tbody, .table-responsive >>> thead {
  text-align: center;
}

.table-responsive >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

.table-responsive >>> .hover-pointer:hover {
  cursor: pointer !important;
}

#textToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}

#textToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

.table-responsive >>> .footer-summary {
  background-color: lightgrey !important;
  text-align: center;
}
.table-responsive >>> tfoot th {
  font-weight: bold !important;
  font-size: 10pt !important;
}

.table-responsive >>> .total-results {
  background-color: rgba(4, 123, 248, 0.1);
}

</style>
